import { useTranslation } from "react-i18next";
import { SmsCampaignsPage as SharedSmsCampaignsPage } from "@wedding/sms-campaigns";
import { useOrganizerApi } from "../hooks/use-organizer-api";
import { useWedding } from "../contexts/wedding-context";

/**
 * Organizer adapter — the page itself lives in `@wedding/sms-campaigns` so the
 * admin panel renders the exact same UI (CLAUDE.md NON-NEGOTIABLE #4).
 * Test-send is ENABLED here: organizers have a verified phone number on file.
 */
export function SmsCampaignsPage() {
  const { wedding, slug } = useWedding();
  const api = useOrganizerApi();
  const { i18n } = useTranslation();
  return (
    <SharedSmsCampaignsPage
      slug={slug}
      wedding={wedding}
      api={api}
      locale={i18n.language}
      testSend={{ enabled: true }}
    />
  );
}
